<template>
    <page
        :showBackButton="true"
        defaultHref="/services/schadensmeldung"
        ref="page"
    >
        <contract-card
            v-if="contractIdForCard !== ''"
            :contractId="contractIdForCard"
            :feature="feature"
            :shouldPresentContractSwitcherModal="
                shouldPresentContractSwitcherModal
            "
        ></contract-card>
        <h1>Schadensmeldung KFZ</h1>
        <form @submit.prevent="submitForm()">
            <stepper v-model="formData.formstep" :count="stepCount">
                <stepper-item :step="1" class="u-form-p-bottom">
                    <ion-card class="-light">
                        <base-input
                            id="kennzeichennummer"
                            v-model="formData.kennzeichennummer"
                            type="text"
                            label="Kennzeichen *"
                            :disabled="isKennzeichennummerDisabled"
                        ></base-input>
                    </ion-card>
                    <personal-data
                        :geschlecht.sync="formData.geschlecht"
                        :titel.sync="formData.titel"
                        :vorname.sync="formData.vorname"
                        :zuname.sync="formData.zuname"
                        :strasse.sync="formData.strasse"
                        :hausnr.sync="formData.hausnr"
                        :stiege.sync="formData.stiege"
                        :stock.sync="formData.stock"
                        :tuer.sync="formData.tuer"
                        :plz.sync="formData.plz"
                        :ort.sync="formData.ort"
                        :email.sync="formData.email"
                        :telefon.sync="formData.telefon"
                        :geburtsdatum.sync="formData.geburtsdatum"
                        suffix=" *"
                    ></personal-data>

                    <beteiligte-data
                        :formData="formData"
                        @person-added="formData.beteiligte.push($event)"
                        @delete-person="formData.beteiligte.splice($event, 1)"
                    >
                    </beteiligte-data>

                    <ion-button
                        expand="block"
                        class="ion-margin-top ion-margin-bottom"
                        @click="submitForm()"
                        >Weiter</ion-button
                    >
                </stepper-item>
                <stepper-item :step="2" class="u-form-p-bottom">
                    <involved-vehicles
                        :kfzart.sync="formData.kfzart"
                        :isKfzartDisabled="isKfzartDisabled"
                        :kfzmarke.sync="formData.kfzmarke"
                        :isKfzmarkeDisabled="isKfzmarkeDisabled"
                        :kmstand.sync="formData.kmstand"
                        :beteiligtKfzart.sync="formData.beteiligtKfzart"
                        :beteiligtKfzmarke.sync="formData.beteiligtKfzmarke"
                        :beteiligtKennzeichennummer.sync="
                            formData.beteiligtKennzeichennummer
                        "
                        :beteiligtKfzversicherung.sync="
                            formData.beteiligtKfzversicherung
                        "
                        :beteiligtPolizze.sync="formData.beteiligtPolizze"
                        :isOtherKfzInvolved.sync="isOtherKfzInvolved"
                    ></involved-vehicles>
                    <ion-grid>
                        <ion-row class="ion-margin-top ion-margin-bottom">
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="stepBack()"
                                    fill="outline"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col size="6">
                                <ion-button expand="block" @click="submitForm()"
                                    >Weiter</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
                <stepper-item
                    class="u-form-p-bottom"
                    :step="3"
                    v-if="showCarglass"
                >
                    <h2>
                        Carglass<sup>®</sup> – Dein Spezialist für
                        Fahrzeugglas<sup>1</sup>
                    </h2>
                    Willst du den Service von Carglass<sup>®</sup> in Anspruch
                    nehmen?
                    <base-select
                        v-model="formData.carglass"
                        id="carglass"
                        placeholder="Bitte wählen"
                        interfaceValue="action-sheet"
                    >
                        <ion-select-option value="Ja">Ja</ion-select-option>
                        <ion-select-option value="Nein">Nein</ion-select-option>
                    </base-select>
                    <div style="font-size: small;">
                        Falls du "Ja" wählst, wirst du nach dem Absenden
                        baldmöglichst durch Carglass<sup>®</sup> kontaktiert.
                    </div>
                    <template
                        v-if="
                            !$store.state.isLoggedIn &&
                            formData.carglass === 'Ja'
                        "
                    >
                        <base-select
                            v-model="formData.carglassVersicherungsart"
                            id="carglass-versicherungsart"
                            placeholder="Bitte wählen"
                            label="KFZ-Versicherungsart *"
                            class="ion-margin-top"
                        >
                            <ion-select-option value="Kaskoversicherung"
                                >Kaskoversicherung</ion-select-option
                            >
                            <ion-select-option value="Nur Haftpflicht"
                                >Nur Haftpflicht</ion-select-option
                            >
                        </base-select>
                        <div
                            v-if="
                                formData.carglassVersicherungsart ===
                                'Nur Haftpflicht'
                            "
                            class="ion-margin-top"
                        >
                            <ion-card class="-danger">
                                Der kostenlose Reparatur-Service sowie die
                                Selbstbehaltsreduktion von
                                <a
                                    href="#"
                                    style="
                                        color: #000;
                                        text-decoration: underline;
                                    "
                                    @click.prevent="
                                        Browser.open({
                                            url:
                                                'https://www.klickmal.at/mobilitaet/kfz-versicherung/carglass.html',
                                        })
                                    "
                                    >Carglass</a
                                ><sup>®</sup>
                                ist leider nur für Kaskokunden möglich. Nähere
                                Infos findest du
                                <a
                                    href="#"
                                    style="
                                        color: #000;
                                        text-decoration: underline;
                                    "
                                    @click.prevent="
                                        Browser.open({
                                            url:
                                                'https://www.klickmal.at/mobilitaet/kfz-versicherung/carglass.html',
                                        })
                                    "
                                    >hier</a
                                >.
                            </ion-card>
                        </div>
                        <template
                            v-if="
                                formData.carglassVersicherungsart ===
                                'Kaskoversicherung'
                            "
                        >
                            <base-input
                                id="carglass-polizzenversicherung"
                                v-model="formData.polizzenversicherung"
                                type="text"
                                label="Polizzen-Nr. KFZ-Versicherung *"
                            ></base-input>
                            <!-- <base-input
                                id="modrive-leistung"
                                v-model="formData.modriveLeistung"
                                type="number"
                                label="Leistung in KW"
                            ></base-input> -->
                        </template>
                    </template>
                    <!-- <base-select
                        v-model="formData.modriveFahrtuechtig"
                        id="modrive-fahrtuechtig"
                        placeholder="Bitte wählen"
                        v-if="
                            formData.modrive === 'Ja' &&
                            ($store.state.isLoggedIn ||
                                formData.modriveVersicherungsart ===
                                    'Kaskoversicherung')
                        "
                        label="Ist das Fahrzeug fahrtüchtig? *"
                        class="ion-margin-top"
                    >
                        <ion-select-option value="Ja">Ja</ion-select-option>
                        <ion-select-option value="Nein">Nein</ion-select-option>
                    </base-select> -->
                    <div class="ion-margin-top">
                        <ion-card>
                            <b>Deine Carglass<sup>®</sup> Vorteile:</b>
                            <ul>
                                <li>200 EUR Selbstbehalt sparen<sup>2</sup></li>
                                <li>
                                    Front-, Heck- und Seitenscheiben in
                                    Erstausrüsterqualität
                                </li>
                                <li>
                                    Zahlreiche Service Center in ganz Österreich
                                </li>
                                <li>
                                    Lebenslange Garantie auf die Arbeit von
                                    Carglass<sup>®</sup><sup>3</sup>
                                </li>
                            </ul>
                            <span>
                                Bei Fragen stehen die Carglass<sup>®</sup>
                                Mitarbeiter unter
                                <a href="tel:+43800230230">0800 230 230</a>
                                oder unter
                                <a
                                    href="https://www.carglass.at"
                                    target="_blank"
                                    >www.carglass.at</a
                                >
                                gerne zur Verfügung.
                            </span>
                            <img
                                :src="
                                    baseurl +
                                    '/content/dam/klickmal/me1ns/images/carglass_logo.png'
                                "
                                class="c-modrive-logo"
                            />
                        </ion-card>
                    </div>
                    <base-checkbox
                        v-model="formData.carglassDatenschutz"
                        v-if="
                            formData.carglass === 'Ja' &&
                            ($store.state.isLoggedIn ||
                                formData.carglassVersicherungsart ===
                                    'Kaskoversicherung')
                        "
                        id="carglass-datenschutz"
                        lines="none"
                        label="Ich stimme zu, dass meine notwendigen personenbezogenen Daten zur Erbringung der Schadensbearbeitung von Wüstenrot automationsunterstützt verarbeitet und zu diesem Zweck an Carglass Austria GmbH übermittelt werden. Carglass sichert dir zu, dass deine Angaben entsprechend den geltenden <a href='https://www.carglass.at/datenschutz/' target='_blank' @click.stop>datenschutzrechtlichen Bestimmungen</a> vertraulich behandelt werden. *"
                    ></base-checkbox>
                    <ion-grid>
                        <ion-row class="ion-margin-top ion-margin-bottom">
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="stepBack()"
                                    fill="outline"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="checkCarglass()"
                                    >Weiter</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                    <div style="font-size: small;" class="ion-padding-top">
                        <p><sup>1</sup> gültig bis 31.12.2022</p>
                        <p>
                            <sup>2</sup> Voraussetzung für die Inanspruchnahme
                            dieser Reduktion des Selbstbehalts durch deine
                            Wüstenrot-Kaskoversicherung sind ein
                            ersatzpflichtiger Kasko-Versicherungsfall und das
                            Bestehen einer entsprechend gültigen Kasko-Polizze
                            bei der Wüstenrot Versicherungs-AG.
                        </p>
                        <p>
                            <sup>3</sup> Du erhältst eine lebenslange Garantie
                            auf die Haltbarkeit bei Steinschlagreparaturen und
                            die Dichtheit bei Neueinbau der Scheibe.
                        </p>
                    </div>
                </stepper-item>
                <stepper-item
                    class="u-form-p-bottom"
                    :step="3 + showCarglass"
                    v-if="showModrive"
                >
                    <h2>MO'Drive Reparatur-Service</h2>
                    Willst du den Reparatur-Service von MO'Drive inkl. gratis
                    Leihauto und Hol- und Bringservice nutzen? <sup>1</sup>
                    <base-select
                        v-model="formData.modrive"
                        id="modrive"
                        placeholder="Bitte wählen"
                        interfaceValue="action-sheet"
                    >
                        <ion-select-option value="Ja">Ja</ion-select-option>
                        <ion-select-option value="Nein">Nein</ion-select-option>
                    </base-select>
                    <!-- <div class="ion-margin-bottom" style="font-size: small;">
                        Einfach „Ja“ auswählen und du musst keine weiteren
                        Veranlassungen treffen – du wirst umgehend von MO'Drive
                        kontaktiert.
                    </div> -->
                    <div style="font-size: small;">
                        Wenn du „Ja“ wählst, wirst du umgehend nach dem Absenden
                        von MO'Drive kontaktiert.
                    </div>
                    <template
                        v-if="
                            !$store.state.isLoggedIn &&
                            formData.modrive === 'Ja'
                        "
                    >
                        <base-select
                            v-model="formData.modriveVersicherungsart"
                            id="modrive-versicherungsart"
                            placeholder="Bitte wählen"
                            label="KFZ-Versicherungsart *"
                            class="ion-margin-top"
                        >
                            <ion-select-option value="Kaskoversicherung"
                                >Kaskoversicherung</ion-select-option
                            >
                            <ion-select-option value="Nur Haftpflicht"
                                >Nur Haftpflicht</ion-select-option
                            >
                        </base-select>
                        <div
                            v-if="
                                formData.modriveVersicherungsart ===
                                'Nur Haftpflicht'
                            "
                            class="ion-margin-top"
                        >
                            <ion-card class="-danger">
                                Der Reparatur-Service von MO'Drive ist leider
                                nur für Kaskokunden möglich. Du fährst daher
                                ohne MO'Drive fort. Nähere Infos findest du
                                <a
                                    href="#"
                                    style="
                                        color: #000;
                                        text-decoration: underline;
                                    "
                                    @click.prevent="
                                        Browser.open({
                                            url:
                                                'https://www.klickmal.at/mobilitaet/kfz-versicherung/mo-drive.html',
                                        })
                                    "
                                    >hier</a
                                >.
                            </ion-card>
                        </div>
                        <template
                            v-if="
                                formData.modriveVersicherungsart ===
                                'Kaskoversicherung'
                            "
                        >
                            <base-input
                                id="modrive-polizzenversicherung"
                                v-model="formData.polizzenversicherung"
                                type="text"
                                label="Polizzen-Nr. KFZ-Versicherung *"
                            ></base-input>
                            <!-- <base-input
                                id="modrive-fin"
                                v-model="formData.modriveFin"
                                type="text"
                                label="Fahrzeug-Identifizierungsnummer (FIN)"
                            ></base-input>
                            <base-datetime
                                label="Erstzulassungsdatum"
                                v-model="formData.modriveErstzulassungsdatum"
                                id="modrive-erstzulassungsdatum"
                                :showNativeInput="true"
                                placeholder="TT.MM.JJJJ"
                                infoText="Das Erstzulassungsdatum muss im Format TT.MM.JJJJ eingegeben werden."
                            ></base-datetime> -->
                            <base-input
                                id="modrive-leistung"
                                v-model="formData.modriveLeistung"
                                type="number"
                                label="Leistung in KW"
                            ></base-input>
                        </template>
                    </template>
                    <base-select
                        v-model="formData.modriveFahrtuechtig"
                        id="modrive-fahrtuechtig"
                        placeholder="Bitte wählen"
                        v-if="
                            formData.modrive === 'Ja' &&
                            ($store.state.isLoggedIn ||
                                formData.modriveVersicherungsart ===
                                    'Kaskoversicherung')
                        "
                        label="Ist das Fahrzeug fahrtüchtig? *"
                        class="ion-margin-top"
                    >
                        <ion-select-option value="Ja">Ja</ion-select-option>
                        <ion-select-option value="Nein">Nein</ion-select-option>
                    </base-select>
                    <div class="ion-margin-top">
                        <ion-card>
                            <b>Deine MO'Drive Vorteile <sup>1</sup></b>
                            <ul>
                                <li>
                                    EUR 100,00 weniger Selbstbehalt
                                    <sup>2</sup>
                                </li>
                                <li>
                                    Kostenloses Ersatzfahrzeug für die Dauer der
                                    Reparatur
                                </li>
                                <li>Kostenloses Hol- und Bringservice</li>
                                <li>
                                    Kostenlose Innen- und Außenreinigung
                                </li>
                                <li>
                                    Reparatur nur mit Originalersatzteilen durch
                                    MO'Drive Fachwerkstätten
                                </li>
                            </ul>
                            <span>
                                Bei Fragen, wende dich bitte an die
                                <a href="tel:+4317695690"
                                    >MO’Drive 24-Stunden Hotline</a
                                >
                                oder sende eine E-Mail an
                                <a href="mailto:termin@modrive.at"
                                    >termin@modrive.at</a
                                >.
                            </span>
                            <img
                                :src="
                                    baseurl +
                                    '/content/dam/klickmal/me1ns/images/modrive_logo.jpg'
                                "
                                class="c-modrive-logo"
                            />
                        </ion-card>
                    </div>
                    <base-checkbox
                        v-model="formData.modriveDatenschutz"
                        v-if="
                            formData.modrive === 'Ja' &&
                            ($store.state.isLoggedIn ||
                                formData.modriveVersicherungsart ===
                                    'Kaskoversicherung')
                        "
                        id="modrive-datenschutz"
                        lines="none"
                        label="Ich stimme zu, dass meine notwendigen personenbezogenen Daten zur Erbringung der Schadensbearbeitung von Wüstenrot automationsunterstützt verarbeitet und zu diesem Zweck an MO'Drive Wiesenthal Handel und Service GmbH übermittelt werden. MO'Drive sichert dir zu, dass deine Angaben entsprechend den geltenden <a href='https://modrive.at/datenschutz-impressum/' target='_blank' @click.stop>datenschutzrechtlichen Bestimmungen</a> vertraulich behandelt werden. *"
                    ></base-checkbox>
                    <ion-grid>
                        <ion-row class="ion-margin-top ion-margin-bottom">
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="stepBack()"
                                    fill="outline"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="checkModrive()"
                                    >Weiter</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                    <div style="font-size: small;" class="ion-padding-top">
                        <p>
                            <sup>1</sup> MO'Drive Service ist kostenlos für
                            Wüstenrot KFZ-Kaskokunden im Fall einer
                            Schadensdeckung durch die Wüstenrot
                            Versicherungs-AG. Gilt nur für 2-spurige Fahrzeuge
                            unter 7,5 Tonnen.
                        </p>
                        <p>
                            <sup>2</sup> Ein allfälliger Selbstbehalt wird nur
                            dann um den Betrag von 100 EUR (inkl USt) reduziert,
                            wenn der Nettoreparaturumsatz am Fahrzeug pro
                            Schadensfall den Betrag von 600 EUR überschreitet.
                        </p>
                    </div>
                </stepper-item>
                <stepper-item
                    :step="3 + showModrive + showCarglass"
                    class="u-form-p-bottom"
                >
                    <accident-data
                        :unfallDatum.sync="formData.unfallDatum"
                        :unfallUhrzeit.sync="formData.unfallUhrzeit"
                        :unfallStrasse.sync="formData.unfallStrasse"
                        :unfallHausnr.sync="formData.unfallHausnr"
                        :unfallStiege.sync="formData.unfallStiege"
                        :unfallStock.sync="formData.unfallStock"
                        :unfallTuer.sync="formData.unfallTuer"
                        :unfallPlz.sync="formData.unfallPlz"
                        :unfallOrt.sync="formData.unfallOrt"
                        :unfallLand.sync="formData.unfallLand"
                        :unfallBeschreibung.sync="formData.unfallBeschreibung"
                        @place-is-home-address="fillPlaceData()"
                    ></accident-data>
                    <ion-grid>
                        <ion-row class="ion-margin-top ion-margin-bottom">
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="stepBack()"
                                    fill="outline"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col size="6">
                                <ion-button expand="block" type="submit"
                                    >Weiter</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
                <stepper-item
                    :step="4 + showModrive + showCarglass"
                    class="u-form-p-bottom"
                >
                    <ion-card class="-light">
                        <ion-grid>
                            <ion-row>
                                <ion-col size="12">
                                    <base-select
                                        v-model="formData.entstandenerschaden"
                                        id="entstandenerschaden"
                                        label="Entstandener Schaden"
                                    >
                                        <ion-select-option value="an beiden KFZ"
                                            >an beiden KFZ</ion-select-option
                                        >
                                        <ion-select-option
                                            value="am eigenen KFZ"
                                            >am eigenen KFZ</ion-select-option
                                        >
                                        <ion-select-option
                                            value="am fremden KFZ"
                                            >am fremden KFZ</ion-select-option
                                        >
                                    </base-select>
                                </ion-col>
                                <ion-col size="12">
                                    <base-select
                                        v-model="formData.schadenArt"
                                        id="schaden-art"
                                        label="Art des Schadens"
                                    >
                                        <ion-select-option
                                            text-wrap
                                            value="Kollision mit fremdem KFZ"
                                            >Kollision mit fremdem
                                            KFZ</ion-select-option
                                        >
                                        <ion-select-option
                                            value="Kollision mit fremden Sachen"
                                            >Kollision mit fremden
                                            Sachen</ion-select-option
                                        >
                                        <ion-select-option value="Parkschaden"
                                            >Parkschaden</ion-select-option
                                        >
                                        <ion-select-option
                                            value="Einbruch/Diebstahl"
                                            >Einbruch/Diebstahl</ion-select-option
                                        >
                                        <ion-select-option value="Vandalismus"
                                            >Vandalismus</ion-select-option
                                        >
                                        <ion-select-option value="Sonstiges"
                                            >Sonstiges</ion-select-option
                                        >
                                    </base-select>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                    <ion-card class="-light">
                        <ion-list-header
                            >Schaden am eigenen KFZ</ion-list-header
                        >
                        <ion-grid>
                            <ion-row>
                                <ion-col>
                                    <base-number-input
                                        v-model="formData.schadenHoehe"
                                        label="Geschätzte Schadenshöhe"
                                        id="schaden-hoehe"
                                    ></base-number-input>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>
                                    <base-textarea
                                        id="schaden-beschreibung"
                                        v-model="formData.schadenBeschreibung"
                                        label="Beschreibung des Schadens *"
                                    ></base-textarea>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                    <ion-card class="-light" v-if="isOtherKfzInvolved">
                        <ion-list-header
                            >Schaden am fremden KFZ</ion-list-header
                        >
                        <ion-grid>
                            <ion-row>
                                <ion-col>
                                    <base-number-input
                                        v-model="formData.schadenHoeheFremd"
                                        label="Geschätzte Schadenshöhe"
                                        id="schaden-hoehe-fremd"
                                    ></base-number-input>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>
                                    <base-textarea
                                        id="schaden-beschreibung-fremd"
                                        :value="
                                            formData.schadenBeschreibungFremd
                                        "
                                        label="Beschreibung des Schadens"
                                        @input="
                                            $emit(
                                                'update:schadenBeschreibungFremd',
                                                $event
                                            )
                                        "
                                    ></base-textarea>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                    <ion-card class="-light">
                        <ion-list-header>Sonstiger Sachschaden</ion-list-header>
                        <ion-grid>
                            <ion-row>
                                <ion-col>
                                    <base-number-input
                                        v-model="formData.schadenHoeheSonstig"
                                        label="Geschätzte Schadenshöhe"
                                        id="schaden-hoehe-sonstig"
                                    ></base-number-input>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>
                                    <base-textarea
                                        id="schaden-beschreibung-sonstig"
                                        :value="
                                            formData.schadenBeschreibungSonstig
                                        "
                                        label="Beschreibung des Schadens"
                                        @input="
                                            $emit(
                                                'update:schadenBeschreibungFremd',
                                                $event
                                            )
                                        "
                                    ></base-textarea>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                    <ion-card class="-light">
                        <ion-list-header>Unfallfotos</ion-list-header>
                        <ion-grid>
                            <ion-row>
                                <ion-col>
                                    <h5>Eigenes KFZ</h5>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>
                                    <files-upload
                                        class="ion-margin-bottom"
                                        v-model="formData.unfallfotosEigene"
                                        :multiple="true"
                                        id="unfallfotosEigene"
                                    ></files-upload>
                                </ion-col>
                            </ion-row>
                            <template v-if="isOtherKfzInvolved">
                                <ion-row>
                                    <ion-col>
                                        <h5>Fremdes KFZ</h5>
                                    </ion-col>
                                </ion-row>
                                <ion-row>
                                    <ion-col>
                                        <files-upload
                                            class="ion-margin-bottom"
                                            v-model="formData.unfallfotosFremd"
                                            :multiple="true"
                                            id="unfallfotosFremd"
                                        ></files-upload>
                                    </ion-col>
                                </ion-row>
                            </template>
                            <ion-row>
                                <ion-col>
                                    <h5>Unfallbericht und Sonstiges</h5>
                                </ion-col>
                            </ion-row>
                            <ion-row>
                                <ion-col>
                                    <files-upload
                                        class="ion-margin-bottom"
                                        v-model="formData.unfallfotosSonstige"
                                        :multiple="true"
                                        id="unfallfotosSonstige"
                                    ></files-upload>
                                </ion-col>
                            </ion-row>
                        </ion-grid>
                    </ion-card>
                    <ion-grid>
                        <ion-row class="ion-margin-top ion-margin-bottom">
                            <ion-col size="6">
                                <ion-button
                                    expand="block"
                                    @click="stepBack()"
                                    fill="outline"
                                    >Zurück</ion-button
                                >
                            </ion-col>
                            <ion-col size="6">
                                <ion-button expand="block" @click="submitForm()"
                                    >Absenden</ion-button
                                >
                            </ion-col>
                        </ion-row>
                    </ion-grid>
                </stepper-item>
            </stepper>
        </form>
    </page>
</template>

<script>
import Page from "@/components/Page";
import PersonalData from "@/components/PersonalData";
import Stepper from "@/components/Stepper";
import StepperItem from "@/components/StepperItem";
import BaseSelect from "@/components/BaseSelect";
import BaseInput from "@/components/BaseInput";
import AccidentData from "@/components/AccidentData";
import BaseNumberInput from "@/components/BaseNumberInput";
import BaseTextarea from "@/components/BaseTextarea";
import { schadensmeldung } from "@/mixins/schadensmeldung";
import InvolvedVehicles from "@/components/InvolvedVehicles";
import FilesUpload from "@/components/FilesUpload";
import BeteiligteData from "@/components/BeteiligteData";
import ContractCard from "@/components/ContractCard";
import { BASEURL } from "@/utils/globals";
import BaseCheckbox from "@/components/BaseCheckbox";
// import BaseDatetime from "@/components/BaseDatetime";
import { Plugins } from "@capacitor/core";

export default {
    mixins: [schadensmeldung],
    components: {
        Page,
        PersonalData,
        Stepper,
        StepperItem,
        BaseSelect,
        BaseInput,
        AccidentData,
        BaseNumberInput,
        BaseTextarea,
        InvolvedVehicles,
        FilesUpload,
        BeteiligteData,
        ContractCard,
        BaseCheckbox,
        // BaseDatetime,
    },
    data() {
        return {
            baseurl: BASEURL,
            isOtherKfzInvolved: false,
            feature: "SchadensmeldungKfz",
            isKennzeichennummerDisabled: false,
            isKfzmarkeDisabled: false,
            isKfzartDisabled: false,
            Browser: Plugins.Browser,
            formData: {
                mode: "kfz",
                formstep: 1,
                kennzeichennummer: "",
                geschlecht: "",
                titel: "",
                vorname: "",
                zuname: "",
                strasse: "",
                hausnr: "",
                stiege: "",
                stock: "",
                tuer: "",
                plz: "",
                ort: "",
                email: "",
                telefon: "",
                geburtsdatum: "",
                kfzart: "",
                kfzmarke: "",
                kmstand: "",
                beteiligtKfzart: "",
                beteiligtKfzmarke: "",
                beteiligtKennzeichennummer: "",
                beteiligtKfzversicherung: "",
                beteiligtPolizze: "",
                unfallDatum: "",
                unfallUhrzeit: "",
                unfallStrasse: "",
                unfallHausnr: "",
                unfallStiege: "",
                unfallStock: "",
                unfallTuer: "",
                unfallPlz: "",
                unfallOrt: "",
                unfallLand: "",
                unfallBeschreibung: "",
                entstandenerschaden: "",
                schadenArt: "",
                schadenHoehe: "",
                schadenBeschreibung: "",
                schadenHoeheFremd: "",
                schadenBeschreibungFremd: "",
                polizzenversicherung: "",

                carglass: "",
                carglassVersicherungsart: "",
                carglassDatenschutz: false,

                modrive: "",
                modriveFahrtuechtig: "",
                isModrivePossible: false,
                modriveDatenschutz: false,
                modriveVersicherungsart: "",
                modriveFin: "",
                modriveErstzulassungsdatum: "",
                modriveLeistung: "",

                unfallfotosEigene: [],
                unfallfotosFremd: [],
                unfallfotosSonstige: [],
                beteiligte: [],
            },
        };
    },
    watch: {
        showCarglass(value) {
            if (!value) {
                this.formData.carglass = "";
            }
        },
        showModrive(value) {
            if (!value) {
                this.formData.modrive = "";
            }
        },
    },
    computed: {
        showCarglass() {
            let result = false;
            if (
                (this.contractDetails &&
                    this.contractDetails.CarGlassPossible) ||
                (!this.$store.state.isLoggedIn &&
                    this.formData.kfzart === "PKW")
            ) {
                result = true;
            }
            return result;
        },
        showModrive() {
            let result = false;
            if (
                this.formData.carglass !== "Ja" &&
                ((this.contractDetails &&
                    this.contractDetails.MoDrivePossible) ||
                    (!this.$store.state.isLoggedIn &&
                        this.formData.kfzart === "PKW"))
            ) {
                result = true;
            }
            return result;
        },
        stepCount() {
            return 4 + this.showCarglass + this.showModrive;
        },
    },
    methods: {
        checkCarglass() {
            if (this.formData.carglass === "") {
                this.$ionic.alertController
                    .create({
                        header: "Bitte beachten",
                        message:
                            "Bitte wähle aus, ob du den Reparatur-Service von Carglass nutzen willst.",
                        buttons: ["OK"],
                    })
                    .then((a) => {
                        a.present();
                    });
            } else if (
                this.formData.carglass === "Ja" &&
                !this.$store.state.isLoggedIn &&
                this.formData.carglassVersicherungsart === "Nur Haftpflicht"
            ) {
                this.formData.formstep++;
            } else if (
                this.formData.carglass === "Ja" &&
                !this.$store.state.isLoggedIn &&
                (this.formData.carglassVersicherungsart === "" ||
                    this.formData.polizzenversicherung === "")
            ) {
                this.$ionic.alertController
                    .create({
                        header: "Bitte beachten",
                        message: "Bitte fülle alle Pflichtfelder aus.",
                        buttons: ["OK"],
                    })
                    .then((a) => {
                        a.present();
                    });
            } else if (
                this.formData.carglass === "Ja" &&
                this.formData.carglassFahrtuechtig === ""
            ) {
                this.$ionic.alertController
                    .create({
                        header: "Bitte beachten",
                        message:
                            "Bitte gib an, ob das Fahrzeug fahrtüchtig ist.",
                        buttons: ["OK"],
                    })
                    .then((a) => {
                        a.present();
                    });
            } else if (
                this.formData.carglass === "Ja" &&
                !this.formData.carglassDatenschutz
            ) {
                this.$ionic.alertController
                    .create({
                        header: "Bitte beachten",
                        message: "Bitte stimme der Datenschutzvereinbarung zu.",
                        buttons: ["OK"],
                    })
                    .then((a) => {
                        a.present();
                    });
            } else {
                this.formData.formstep++;
            }
        },
        checkModrive() {
            if (this.formData.modrive === "") {
                this.$ionic.alertController
                    .create({
                        header: "Bitte beachten",
                        message:
                            "Bitte wähle aus, ob du den Reparatur-Service von MO'Drive inkl. gratis Leihauto und Hol- und Bringservice nutzen willst.",
                        buttons: ["OK"],
                    })
                    .then((a) => {
                        a.present();
                    });
            } else if (
                this.formData.modrive === "Ja" &&
                !this.$store.state.isLoggedIn &&
                this.formData.modriveVersicherungsart === "Nur Haftpflicht"
            ) {
                this.formData.formstep++;
            } else if (
                this.formData.modrive === "Ja" &&
                !this.$store.state.isLoggedIn &&
                (this.formData.modriveVersicherungsart === "" ||
                    this.formData.polizzenversicherung === "")
            ) {
                this.$ionic.alertController
                    .create({
                        header: "Bitte beachten",
                        message: "Bitte fülle alle Pflichtfelder aus.",
                        buttons: ["OK"],
                    })
                    .then((a) => {
                        a.present();
                    });
            } else if (
                this.formData.modrive === "Ja" &&
                this.formData.modriveFahrtuechtig === ""
            ) {
                this.$ionic.alertController
                    .create({
                        header: "Bitte beachten",
                        message:
                            "Bitte gib an, ob das Fahrzeug fahrtüchtig ist.",
                        buttons: ["OK"],
                    })
                    .then((a) => {
                        a.present();
                    });
            } else if (
                this.formData.modrive === "Ja" &&
                !this.formData.modriveDatenschutz
            ) {
                this.$ionic.alertController
                    .create({
                        header: "Bitte beachten",
                        message: "Bitte stimme der Datenschutzvereinbarung zu.",
                        buttons: ["OK"],
                    })
                    .then((a) => {
                        a.present();
                    });
            } else {
                this.formData.formstep++;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.c-modrive-logo {
    width: 120px;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    @media only screen and (max-width: $breakpoint-lg) {
        display: none;
    }
}
</style>
